var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.2,8.4v-7c0-0.8-0.6-1.4-1.4-1.4H1.4C0.6,0,0,0.6,0,1.4V16c0,0.8,0.6,1.4,1.4,1.4h7.5c-0.3-0.8-0.5-1.7-0.5-2.6 C8.4,11.5,10.9,8.7,14.2,8.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.8,9.6c-2.9,0-5.2,2.3-5.2,5.2c0,2.9,2.3,5.2,5.2,5.2c2.9,0,5.2-2.3,5.2-5.2C20,11.9,17.7,9.6,14.8,9.6z M13.9,10.6 c0.3-0.2,0.6-0.3,0.9-0.3c0.4,0,0.7,0.1,0.9,0.3s0.4,0.5,0.4,0.8c0,0.3-0.1,0.6-0.4,0.8c-0.3,0.2-0.6,0.3-0.9,0.3 c-0.4,0-0.7-0.1-0.9-0.3c-0.3-0.2-0.4-0.5-0.4-0.8C13.5,11.1,13.6,10.9,13.9,10.6z M16.9,18.6h-4.3v-0.8c0.5,0,0.8,0,1-0.1 c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1,0-0.2,0-0.4v-1.9c0-0.4,0-0.6-0.1-0.7c-0.1-0.1-0.3-0.2-0.6-0.2h-0.6v-0.8c0.5,0,1,0,1.3-0.1 s0.5-0.1,0.7-0.2c0.1,0,0.3-0.1,0.4-0.1c0.3,0,0.5,0.1,0.6,0.2c0.1,0.2,0.1,0.4,0.1,0.8v3c0,0.3,0.1,0.5,0.2,0.6 c0.2,0.1,0.5,0.2,1.1,0.2V18.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.a7ad3ee9.svg";
export { ForwardRef as ReactComponent };